/*=================================================
    summary: 字典 列表

    remarks: 000 Tim 2021/11/22 Create
             001 Tim 2021/12/23 調整 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssGlossary from './Glossary.module.scss'
import { FixedSizeList as List } from "react-window"
import * as LocalStorage from '../../Data/LocalStorage.js'

import {LoadingMask, AlertWindow, GlobalLibs, NetworkLibs, PackageVariablesLibs, RoutePathLibs} from 'bc-react-package'


// #region State Member Variables
let mstrSearchText = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrDisplayName = ""
let mblnUpdateListContentHeight = false

let mstrUpdatedVersion = ""
let marrGlossary = []
            
let mintNoResultLen = 9999
let marrSearchList = []
let mblnIsExecuteSearch = false

let mobjAuthorizedSubscription = null
// #endregion Member Variables


const COMP_NAME = "Glossary"

function Glossary(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [searchDataTime, setSearchDataTime] = useState(0)
    const [searchText, setSearchText] = useState("")
    const [audioPlayIndex, setAudioPlayIndex] = useState(-1)
    const [listContentHeight, setListContentHeight] = useState(618)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefListContent = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrDisplayName = window.Globals.GetDisplayName()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update updateDataTime
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect updateDataTime")

        if (
            (mblnUpdateListContentHeight) &&
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            mblnUpdateListContentHeight = false
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    }, [updateDataTime])

    // Update searchText
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect searchText")

        mstrSearchText = searchText

        if (mblnIsExecuteSearch)
        {
            mblnIsExecuteSearch = false
            SearchKey(searchText)
        }
    }, [searchText])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false           

            window.removeEventListener('resize', WindowOnResizeEventHandler)

            setUpdateDataTime(0)
            setSearchDataTime(0)
            setSearchText("")
            setAudioPlayIndex(-1)
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: 第一次 顯示 的 時間點
    remarks: 000 Tim 2021/11/19 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function PaintedMe() 
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioCanplayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

        window.addEventListener("resize", WindowOnResizeEventHandler)

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     marrGlossary = TransformGlossary(window.gSession.App.GlossaryDef)
        //     console.log("marrGlossary", marrGlossary)

        //     CreateSourceList()
        // }
        // else
        // {
            mobjCallParam = {
                "BookCategoryID": window.gSession.App.BookCatID,
                "AppVersion": process.env.REACT_APP_LOG_VERSION,
                "Version": GetGlossaryLSElement('Version')
            }
            CheckGlossaryUpdateInfo()
        // }

        setUpdateDataTime(new Date().getTime())

        if (
            (typeof(props.SearchText) !== 'undefined') && 
            (props.SearchText !== null) &&
            (props.SearchText !== '')
            )
        {
            mblnIsExecuteSearch = true
            setSearchText(props.SearchText)
        }
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉 字典視窗
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        
        let objCallbackData = {
            "Action": "CloseShowGlossary"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 一行
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function SourceUnitOnTapHandler(SourceData, SourceIndex)
    {
        console.log(COMP_NAME + ".SourceUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // 送出去那個lesson 的event
        console.log("SourceUnitOnTapHandler LessonID: ", SourceData.LessonID)
        console.log("SourceUnitOnTapHandler LUCatSeqNo: ", SourceData.LUCatSeqNo)

        let strBookSeqNo4While = "01"
        let strBookSeqNo = "01"
        let intBookIndex = 0
        let intBookCount = 4
        let intLessonIndex = 0
        let intLessonCount = 0
        let blnFound = false

        // console.log("SourceUnitOnTapHandler App.BookDef: ", window.gSession.App.BookDef)

        while ((!blnFound) && (intBookIndex < intBookCount))
        {
            strBookSeqNo4While = (intBookIndex + 1).toString().PadLeft(2)
            intLessonIndex = 0
            intLessonCount = window.gSession.App.BookDef[strBookSeqNo4While].Lesson.length

            while ((!blnFound) && (intLessonIndex < intLessonCount))
            {
                if (parseInt(window.gSession.App.BookDef[strBookSeqNo4While].Lesson[intLessonIndex].ID) === parseInt(SourceData.LessonID))
                {
                    strBookSeqNo = (intBookIndex + 1).toString().PadLeft(2)
                    blnFound = true
                }
                intLessonIndex++
            } // end of while
            intBookIndex++
        } // end of while
        console.log("SourceUnitOnTapHandler strBookSeqNo: ", strBookSeqNo)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(SourceData.LessonID))
        {
            blnExpired = false
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo));
        }   
        console.log("SourceUnitOnTapHandler blnExpired: ", blnExpired)

        if (!blnExpired)
        {
            // 讀取 LessonData 流程 改去 Lesson頁面 統一做
            GotoLearningUnit(strBookSeqNo, SourceData.LessonID, SourceData.LUCatSeqNo)
        }
        else
        {
            // 之後 再補 授權提示 這一塊   Tim20.12.15
            console.log("SourceUnitOnTapHandler NoAuthorizedProcess")

            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, SourceData.LessonID, SourceData.LUCatSeqNo);
        } // end of if (blnExpired)
    } // end of SourceUnitOnTapHandler

    /*===========================================
    summary: 點選 播放聲音
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function PlayAudioOnTapHandler(event, StateAudioPlayIndex, SourceIndex, SourceData)
    {
        console.log(COMP_NAME + ".PlayAudioOnTapHandler")

        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateAudioPlayIndex === SourceIndex)
        {
            // 理論上 目前是 Disabled，所以不執行任何動作，因為直接擋掉 此 Event會穿透到下一層 所以還是觸發一下事件，再進來判斷    Tim20.12.15
        }
        else
        {
            let strQueryString = window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION

            let strUrl = PackageVariablesLibs.SysConfig.FileServerURL + "Lesson_"
            strUrl += SourceData.LessonID + "/audio/" 
            strUrl += SourceData.AudioFN 
            strUrl += strQueryString

            setAudioPlayIndex(SourceIndex)

            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

            window.AudioLibs.PlayAudio(strUrl)
        }
    } // end of PlayAudioOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 搜尋 輸入框 改變事件
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function SearchOnChangeHandler(event)
    {
        // console.log(COMP_NAME + ".SearchOnChangeHandler: ", e);

        mblnIsExecuteSearch = true
        setSearchText(event.target.value)
    } // end of SearchOnChangeHandler

    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        setAudioPlayIndex(-1)
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 音檔 讀取完畢 可以播放 
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function AudioCanplayHandler()
    {
        console.log(COMP_NAME + ".AudioCanplayHandler")

        CloseLoadingMask()
    } // end of AudioCanplayHandler

    /*===========================================
    summary: 改變視窗大小
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function WindowOnResizeEventHandler()
    {
        // console.log(COMP_NAME + ".WindowOnResizeEventHandler")
        
        if (
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    } // end of WindowOnResizeEventHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask Functions

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            let objCallbackData = {
                "Action": "OpenSettings4NoAuthorized",
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack

    // #region Other Functions
    /*===========================================
    summary: 取得 Glossary LS 參數
    param: string     ElementKey
            
    retruns: variant    ElementValue
    remarks: 000 Richard 2014/07/7 Create
            001 Tim 2019/09/11 增加安全性檢查 以防 找不到 objAccLSRecord 會直接 壞掉
    ===========================================*/
    function GetGlossaryLSElement(ElementKey)
    {
        console.log(COMP_NAME + ".GetGlossaryLSElement: ", ElementKey)

        let objGlossaryLS = JSON.parse(localStorage.getItem(LocalStorage.GLOSSARY_LS_KEY))
        console.log("objGlossaryLS: ", objGlossaryLS)

        let objOuput = null

        if (
            (typeof (objGlossaryLS) !== 'undefined') &&
            (objGlossaryLS !== null) &&
            (typeof (objGlossaryLS[ElementKey]) !== 'undefined') &&
            (objGlossaryLS[ElementKey] !== null)
            )
        {
            console.log("objGlossaryLS[ElementKey]: ", objGlossaryLS[ElementKey])
            objOuput = objGlossaryLS[ElementKey]
        }

        return objOuput;
    } // end of GetGlossaryLSElement

    /*===========================================
    summary: 設定 Glossary LS 參數
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function SetGlossaryLSElement(ElementKey, ElementValue)
    {
        console.log(COMP_NAME + ".SetGlossaryLSElement: ", ElementKey, ElementValue);

        let objGlossaryLS = JSON.parse(localStorage.getItem(LocalStorage.GLOSSARY_LS_KEY))
        console.log("objGlossaryLS: ", objGlossaryLS)

        objGlossaryLS[ElementKey] = ElementValue

        console.log("objGlossaryLS: ", objGlossaryLS)

        localStorage.setItem(LocalStorage.GLOSSARY_LS_KEY, JSON.stringify(objGlossaryLS))
    } // end of SetGlossaryLSElement

    /*===========================================
    summary: 建立原始詞彙表列表
    remarks: 000 Tim 2022/11/22 Create
    ===========================================*/
    function CreateSourceList ()
    {
        console.log(COMP_NAME + ".CreateSourceList: marrGlossary: ", marrGlossary)

        if (mstrSearchText !== '')
        {
            SearchKey(mstrSearchText)
        }

        mblnUpdateListContentHeight = true

        setUpdateDataTime(new Date().getTime())               
    } // end of CreateSourceList

    /*===========================================
    summary: 轉換 詞彙表 格式 於列表顯示用
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function TransformGlossary (BackendReturnedGlossary)
    {
        console.log(COMP_NAME + ".TransformGlossary")

        let arrList = []
        let objItem = null
        let objLesson = null
        let objLearningUnit = null
        let objSubCategory = null
        let objSentence = null

        // console.log(COMP_NAME + ".TransformGlossary: BackendReturnedGlossary: ", BackendReturnedGlossary);

        // Glossary
        let intIndex4Glossary = 0
        let intCount4Glossary = BackendReturnedGlossary.length

        // LearningUnit
        let intIndex4LU = 0
        let intCount4LU = 0

        // SubCategory
        let intIndex4SubCategory = 0
        let intCount4SubCategory = 0

        // Sentence
        let intIndex4Sentence = 0
        let intCount4Sentence = 0
        
        for (intIndex4Glossary = 0; intIndex4Glossary < intCount4Glossary; intIndex4Glossary++) 
        {
            objLesson = BackendReturnedGlossary[intIndex4Glossary]

            intIndex4LU = 0
            intCount4LU = objLesson.LearningUnit.length
            // 每課單元
            for (intIndex4LU = 0; intIndex4LU < intCount4LU; intIndex4LU++)
            {
                objLearningUnit = objLesson.LearningUnit[intIndex4LU]

                intIndex4SubCategory = 0
                intCount4SubCategory = objLearningUnit.SubCategory.length

                // SubCattegory
                for (intIndex4SubCategory = 0; intIndex4SubCategory < intCount4SubCategory; intIndex4SubCategory++)
                {
                    objSubCategory = objLearningUnit.SubCategory[intIndex4SubCategory]

                    // Sentence
                    intIndex4Sentence = 0
                    intCount4Sentence = objSubCategory.Sentence.length

                    // Sentence
                    for (intIndex4Sentence = 0; intIndex4Sentence < intCount4Sentence; intIndex4Sentence++)
                    {
                        objSentence = objSubCategory.Sentence[intIndex4Sentence]

                        // console.log("Sentence");
                        /***************
                        資料格式
                        AudioFN: "01001_vocab_lesson_01.mp3"
                        Def: "Hello"
                        KBPinyin: null
                        MajorText: "你好"
                        MinorText: "你好"
                        No: "1"
                        Parts: "I.E."
                        Pinyin: "nǐhǎo"
                        SentenceSeqNo: "013"
                        Text: null
                        ***************/
                        objItem = {};
                        objItem.LessonID = objLesson.ID;
                        objItem.LessonName = objLesson.PrefixName;
                        objItem.LUCatSeqNo = objLearningUnit.LUCatSeqNo;
                        objItem.AudioFN = objSentence.AudioFN;
                        objItem.Pinyin = objSentence.Pinyin;
                        objItem.MajorText = objSentence.MajorText;
                        objItem.MinorText = objSentence.MinorText;
                        objItem.Parts = objSentence.Parts;
                        objItem.Def = objSentence.Def;

                        arrList.push(objItem);
                    } // end of for (intIndex4Sentence = 0;
                } // end of for (intIndex4SubCategory = 0;
            } // end of for (intIndex4LU = 0;
        } // end of for (intIndex4Glossary = 0;

        // console.log(COMP_NAME + ".TransformGlossary: arrList: ", arrList);

        return arrList;
    }  // end of TransformGlossary 

    /*===========================================
    summary: 更新 詞彙表資料 到 Local Storage
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function UpdateLSData (GlossaryObject)
    {
        console.log(COMP_NAME + ".UpdateLSData: ", GlossaryObject)

        SetGlossaryLSElement('Glossary', GlossaryObject)
        SetGlossaryLSElement('Version', mstrUpdatedVersion)
        SetGlossaryLSElement('ContentVerType', window.gSession.App.ContentVerType)
    } // end of UpdateLSData

    /*===========================================
    summary: 搜尋 字元
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function SearchKey (SearchValue)
    {
        console.log(COMP_NAME + ".SearchKey: SearchValue: ", SearchValue)

        let strSearch = ""
        let intIndex = 0
        let intCount = 0
        let objItem = null
        let blnAnyMatched = false

        let strTargetText = ""

        strSearch = SearchValue.toLowerCase()

        console.log("SearchKey strSearch: ", strSearch)

        if (strSearch === "")
        {
            setSearchDataTime(0)
        }
        else if (strSearch.length > (mintNoResultLen + 1))     
        {
            // 中文輸入 還沒選字前 可能會被擋掉，
            // 所以多開放一個字元 讓他去跑Search容錯； AIStoryTime ex:春節飲食    Tim19.02.11

            // 不需search
            console.log("no need search!")
        }
        else
        {
            // 需要 search
            mintNoResultLen = 9999

            intCount = marrGlossary.length
            objItem = {}

            marrSearchList = []

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                objItem = marrGlossary[intIndex]

                strTargetText = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? objItem.MajorText.toLowerCase() : objItem.MinorText.toLowerCase()

                if (
                    (strTargetText.indexOf(strSearch) !== -1) || 
                    (objItem.Def.toLowerCase().indexOf(strSearch) !== -1)
                    )
                {
                    // matched
                    marrSearchList.push(objItem)
                    blnAnyMatched = true
                }
                else
                {
                    // not matched
                }
            }

            if (!blnAnyMatched)
            {
                mintNoResultLen = strSearch.length
            }

            console.log("SearchKey marrSearchList: ", marrSearchList)

            setSearchDataTime(new Date().getTime())
        }
    } // end of SearchKey 

    /*===========================================
    summary: 前往 Learning Unit 頁面
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GotoLearningUnit (BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)
    
        let strLessonID = LessonID.PadLeft(5)
        let objLocationState = {
            "BookSeqNo": parseInt(BookSeqNo),
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }

        if (props.ButtonType !== window.gButtonTypeEnum.Lessons)
        {
            RoutePathLibs.Route2Path(props.History, "/Lessons", objLocationState)
        }
        else
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit",
                "LocationState": objLocationState
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of GotoLearningUnit

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!");

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID);
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo);
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID);
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo);

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }
        
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 播放按鈕 Cls
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GetPlayButtonCls(StateAudioPlayIndex, SourceIndex)
    {
        let objCls = cssGlossary.btnPlay

        if (StateAudioPlayIndex === SourceIndex)
        {
            objCls = cssGlossary.btnPlayDisabled
        }

        return objCls
    } // end of GetPlayButtonCls

    /*===========================================
    summary: 取得 Def 欄位 Cls
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GetDefCellCls(DefWordCount) 
    {
        let objCls = cssGlossary.divDefCell

        if (DefWordCount > 80)
        {
            objCls = cssGlossary.divDefCell4Word80
        }
        else if (DefWordCount > 50)
        {
            objCls = cssGlossary.divDefCell4Word50
        }

        return objCls
    } // end of GetDefCellCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 從後端 取得 詞彙表 後續流程
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GetGlossaryFromBackendAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetGlossaryFromBackendAfterProcess")

        mobjCallParam = null
        
        marrGlossary = TransformGlossary(JSON.parse(ReturnData))

        UpdateLSData(marrGlossary)
        console.log(COMP_NAME + ".GetGlossaryFromBackendAfterProcess marrGlossary", marrGlossary);

        CreateSourceList()
    } // end of GetGlossaryFromBackendAfterProcess

    /*===========================================
    summary: 檢查詞彙表更新資訊 後續流程
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function CheckGlossaryUpdateInfoAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".CheckGlossaryUpdateInfoAfterProcess")

        mobjCallParam = null

        let blnNeedToUpdate = false

        if (ReturnData.FileList !== null)
        {
            // need to update
            blnNeedToUpdate = true

            mstrUpdatedVersion = ReturnData.Version
        }

        if (blnNeedToUpdate)
        {
            console.log("need to update")
            // call backend to get Glossary and update local storage
            mobjCallParam = {
                "BookCategoryID": window.gSession.App.BookCatID
            }
            GetGlossaryFromBackend()
        }
        else
        {
            console.log("Get from LS");
            // should get data from local storage
            marrGlossary = GetGlossaryLSElement('Glossary')

            CreateSourceList()
        }
    } // end of CheckGlossaryUpdateInfoAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 檢查詞彙表更新資訊
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function CheckGlossaryUpdateInfo ()
    {
        console.log(COMP_NAME + ".CheckGlossaryUpdateInfo")

        let objRetryFuncRef = CheckGlossaryUpdateInfo
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = CheckGlossaryUpdateInfoCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetGlossaryUpdateInfo)

            let objCallData = {
                "Func": "GetDictionaryUpdateFileListFromFS",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "AppVersion": mobjCallParam.AppVersion,
                "Version": mobjCallParam.Version
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of CheckGlossaryUpdateInfo

    /*===========================================
    summary: 檢查詞彙表更新資訊 Callback
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function CheckGlossaryUpdateInfoCallback (Return)
    {
        console.log(COMP_NAME + ".CheckGlossaryUpdateInfoCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_CheckGlossaryUpdateInfo_No
        let strErrorTitle = window.gAppUI.ERR_CheckGlossaryUpdateInfo_Title
        let strErrMsg = window.gAppUI.ERR_CheckGlossaryUpdateInfo_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("CheckGlossaryUpdateInfoCallback: ErrNo: ", Return.ErrNo)
            console.log("CheckGlossaryUpdateInfoCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("CheckGlossaryUpdateInfoCallback Return.Data: ", Return.Data)

            CheckGlossaryUpdateInfoAfterProcess(Return.Data)
        }
    } // end of CheckGlossaryUpdateInfoCallback

    /*===========================================
    summary: 從後端 取得 詞彙表
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GetGlossaryFromBackend ()
    {
        console.log(COMP_NAME + ".GetGlossaryFromBackend")

        let objRetryFuncRef = GetGlossaryFromBackend
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetGlossaryFromBackendCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetGlossary)

            let objCallData = {
                "Func": "DictionaryJsonFile",
                "BookCategoryID": mobjCallParam.BookCategoryID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetGlossaryFromBackend

    /*===========================================
    summary: 從後端 取得 詞彙表 Callback
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function GetGlossaryFromBackendCallback (Return)
    {
        console.log(COMP_NAME + ".GetGlossaryFromBackendCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetGlossaryData_No
        let strErrorTitle = window.gAppUI.ERR_GetGlossaryData_Title
        let strErrMsg = window.gAppUI.ERR_GetGlossaryData_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetGlossaryFromBackendCallback: ErrNo: ", Return.ErrNo)
            console.log("GetGlossaryFromBackendCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetGlossaryFromBackendCallback Return.Data: ", Return.Data)

            GetGlossaryFromBackendAfterProcess(Return.Data)
        }
    } // end of GetGlossaryFromBackendCallback
    // #endregion Web Service 

    // #region Render元件
    /*===========================================
    summary: Arrow Right Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentArrowRightCell()
    {   
        return(
            <div className={cssGlossary.divArrowRightCell}>
                <div className={cssGlossary.divArrowRightIcon}/>
            </div>
        )
    } // end of ComponentArrowRightCell

    /*===========================================
    summary: Def Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentDefCell( {Def} )
    {   
        return(
            <div className={GetDefCellCls(Def.length)}>
                {Def}
            </div>
        )
    } // end of ComponentDefCell

    /*===========================================
    summary: Parts Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentPartsCell( {Parts} )
    {   
        return(
            <div className={cssGlossary.divPartsCell}>
                <div className={cssGlossary.divParts}>
                    {Parts}
                </div>
            </div>
        )
    } // end of ComponentPartsCell

    /*===========================================
    summary: Pinyin Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentPinyinCell( {Pinyin} )
    {   
        return(
            <div className={cssGlossary.divPinyinCell}>
                <div className={cssGlossary.divPinyin}>
                    {Pinyin}
                </div>
            </div>
        )
    } // end of ComponentPinyinCell

    /*===========================================
    summary: Play Button Cell 空格 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentPlayButtonCellNull()
    {   
        return(
            <div className={cssGlossary.divPlayButtonCellSpacer}>
            </div>
        )
    } // end of ComponentPlayButtonCellNull

    /*===========================================
    summary: Play Button Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentPlayButtonCell( {SourceData, StateAudioPlayIndex, SourceIndex} )
    {   
        return(
            <div className={cssGlossary.divPlayButtonCell}>
                <div className={GetPlayButtonCls(StateAudioPlayIndex, SourceIndex)} onClick={(event) => PlayAudioOnTapHandler(event, StateAudioPlayIndex, SourceIndex, SourceData)} />
            </div>
        )
    } // end of ComponentPlayButtonCell

    /*===========================================
    summary: Text Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentTextCell( {SourceData} )
    {   
        let strText = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SourceData.MajorText : SourceData.MinorText

        return(
            <div className={cssGlossary.divTextCell}>
                <div className={cssGlossary.divText}>
                    {strText}
                </div>        
            </div>
        )
    } // end of ComponentTextCell

    /*===========================================
    summary: Lesson Name Cell 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentLessonNameCell( {LessonName} )
    {   
        let strText = LessonName + ":"
        return(
            <div className={cssGlossary.divLessonNameCell}>
                <div className={cssGlossary.divLessonName}>
                    {strText}
                </div>
            </div>
        )
    } // end of ComponentLessonNameCell

    /*===========================================
    summary: Search Title 顯示Component  
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function ComponentSearchTitle()
    {   
        return(
            <div className={cssGlossary.divSearchTitle}>
                {window.gAppUI.LBL_SearchLabel}
            </div>
        )
    } // end of ComponentSearchTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/22 Create
             001 Tim 2022/01/17 將 Close 感應區改大
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssGlossary.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssGlossary.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssGlossary.divTitle}>
                {window.gAppUI.LBL_Glossary}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function ComponentDisplayName( {DisplayName} )
    {   
        return(
            <div className={cssGlossary.divDisplayName}>
                {DisplayName}
            </div>
        )
    } // end of ComponentDisplayName
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 列表 每列 資料內容 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderSourceRowWrapper(ListData, DataList, StateAudioPlayIndex)
    {
        let objSourceData = DataList[ListData.index]

        return (
            <div className="row" style={ListData.style}>
                <div className={cssGlossary.divSourceUnit}  onClick={() => SourceUnitOnTapHandler(objSourceData)}>
                    <ComponentLessonNameCell LessonName={objSourceData.LessonName} />

                    <ComponentTextCell SourceData={objSourceData} />

                    <ComponentPlayButtonCellNull />

                    <ComponentPinyinCell Pinyin={objSourceData.Pinyin} />

                    <ComponentPartsCell Parts={objSourceData.Parts} />

                    <ComponentDefCell Def={objSourceData.Def} />

                    <ComponentArrowRightCell />
                </div>

                <ComponentPlayButtonCell SourceData={objSourceData} StateAudioPlayIndex={StateAudioPlayIndex} SourceIndex={ListData.index}/>
            </div>
        )
    } // end of RenderSourceRowWrapper

    /*===========================================
    summary: Render List元件 資料內容 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderListUnitWrapper(StateSearchDataTime)
    {
        if (StateSearchDataTime === 0)
        {      
            return (
                <List width={'100%'} height={listContentHeight}
                    itemCount={marrGlossary.length} itemSize={60}
                    audioplayindex={audioPlayIndex}>
                    {(ListData) => RenderSourceRowWrapper(ListData, marrGlossary, audioPlayIndex)}
                </List>
            )
        }
        else if (StateSearchDataTime > 0)
        {
            return (
                <List width={'100%'} height={listContentHeight}
                    itemCount={marrSearchList.length} itemSize={60}
                    audioplayindex={audioPlayIndex}>
                    {(ListData) => RenderSourceRowWrapper(ListData, marrSearchList, audioPlayIndex)}
                </List>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderListUnitWrapper

    /*===========================================
    summary: Render 列表 資料內容 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderSourceListWrapper(StateUpdateDataTime, StateSearchDataTime)
    {
        if (StateUpdateDataTime > 0)
        {      
            return (
                <div className={cssGlossary.divSourceList}>
                    {RenderListUnitWrapper(searchDataTime)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSourceListWrapper

    /*===========================================
    summary: Render Search Tool 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderSearchToolWrapper()
    {
        return (
            <div className={cssGlossary.divSearchTool}>
                <ComponentSearchTitle />

                <div className={cssGlossary.divSearchMain}>
                    <label htmlFor="SearchText" className={cssGlossary.divHidden}>
                        {window.gAppUI.LBL_Label}
                    </label>
                    <input id="SearchText" type="text" 
                        value={searchText}
                        className={cssGlossary.txtSearch}
                        placeholder={window.gAppUI.LBL_SearchPlaceHolder}
                        onChange={(event) => SearchOnChangeHandler(event)}
                    />
                    <div className={cssGlossary.divSearchIcon}/>
                </div>
            </div>
        )
    } // end of RenderSearchToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssGlossary.divContent}>
                {RenderSearchToolWrapper()}

                <div className={cssGlossary.divSearchToolLine}/>

                <div ref={mrefListContent} className={cssGlossary.divListContent}>
                    {RenderSourceListWrapper(updateDataTime)}
                </div>
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssGlossary.divTopTool}>
                <ComponentDisplayName DisplayName={mstrDisplayName}/>

                <ComponentTitle />

                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/22 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssGlossary.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper()}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Glossary